//React
import React from "react";

//Material-ui
import Box from '@material-ui/core/Box';



const Card = (props) => {
  let background;
  if (props.select) {
    background = "#E7B0D0";
  }
  else {
    background = "#FFF";
  }

	return (
		<Box
      className='round12'
      boxShadow={2}
      style={{
        background:background,
        padding:'10px',
        fontSize:'0.9em',
      }}
    >
      {props.children}
		</Box>
	)
}


const Graph = (props) => {
  let style;
  if (props.count > 0) {
    style = {
      width: props.count * 20 + 'px',
      height:'20px',
      left: '50%',
      background:'#999',
      position: 'absolute',
    }
  }
  else {
    style = {
      width: props.count * 20 * -1 + 'px',
      height:'20px',
      right: '50%',
      background:'#999',
      position: 'absolute',
    }
  }

	return (
    <div style={{
      width:'280px',
      height:'20px',
      background:'#FFF',
      position: 'relative',
    }}>
      <span
        style={style}
      >
      </span>
    </div>
	)
}

class Comp extends React.Component {

  render() {
    return (
      <div style={{padding:'10px'}}>

        <h2 align='center'>4つの指向</h2>

        <table border='0' cellPadding='3' style={{width:'100%'}}>
          <tbody>
            <tr>
              <td align='center'><h2>内向型 I</h2></td>
              <td align='center'><h2>外向型 E</h2></td>
            </tr>
            <tr>
              <td align='right'>
                <Card
                  select={ this.props.type16.match(/I/) }
                >
                  一人の時間も大切<br/>趣味に凝る<br/>心の内面を意識
                </Card>
              </td>

              <td align='left'>
                <Card
                  select={ this.props.type16.match(/E/) }
                >
                  会話が好き<br/>進んで人と関わる<br/>周囲との関係を意識
                </Card>
              </td>
            </tr>
            <tr>
              <td colSpan='2' align='center'>
                <div>行動と情報の範囲</div>
                <Graph
                  count={this.props.countEI}
                />
              </td>
            </tr>
            <tr>
              <td align='center'><h2>直感型 N</h2></td>
              <td align='center'><h2>現実型 S</h2></td>
            </tr>
            <tr>
              <td align='right'>
                <Card
                  select={ this.props.type16.match(/N/) }
                >
                  現在より将来<br/>可能性に重きを置く<br/>ひらめきを重視
                </Card>
              </td>
              <td align='left'>
                <Card
                  select={ this.props.type16.match(/S/) }
                >
                  未来より現在<br/>堅実さに重きを置く<br/>経験を重視
                </Card>
              </td>
            </tr>
            <tr>
              <td colSpan='2' align='center'>
                <div>情報の重要度と精査</div>
                <Graph
                  count={this.props.countSN}
                />
              </td>
            </tr>
            <tr>
              <td align='center'><h2>感情型 F</h2></td>
              <td align='center'><h2>思考型 T</h2></td>
            </tr>
            <tr>
              <td align='right'>
                <Card
                  select={ this.props.type16.match(/F/) }
                >
                  情にもろい<br/>人への影響を考える<br/>やさしい印象
                </Card>
              </td>
              <td align='left'>
                <Card
                  select={ this.props.type16.match(/T/) }
                >
                  意志が強い<br/>論理的に考える<br/>厳格な印象
                </Card>
              </td>
            </tr>
            <tr>
              <td colSpan='2' align='center'>
                <div>判断への感情移入</div>
                <Graph
                  count={this.props.countTF}
                />
            </td>
            </tr>
            <tr>
              <td align='center'><h2>柔軟型 p</h2></td>
              <td align='center'><h2>規範型 j</h2></td>
            </tr>
            <tr>
              <td align='right'>
                <Card
                  select={ this.props.type16.match(/p/) }
                >
                  格式ばらない<br/>状況に応じて行動<br/>マイペース
                </Card>
              </td>
              <td align='left'>
                <Card
                  select={ this.props.type16.match(/j/) }
                >
                  決断するのが得意<br/>几帳面で規律正しい<br/>期限を守る
                </Card>
              </td>
            </tr>
            <tr>
              <td colSpan='2' align='center'>
                <div>実行の維持と再考</div>
                <Graph
                  count={this.props.countJP}
                />
                </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default Comp;
